module.exports = __webpack_public_path__ + "img/icon_recycle_bin_selected.62406de3.png";